<template>
    <!-- Main Sidebar Container -->
    <aside class="main-sidebar elevation-4 sidebar-dark-marron">
        <a href="#" class="brand-link animation__shake wow fadeInDown"
            style="align-items: center;position: absolute;top: 25px;" data-widget="pushmenu" role="button">
            <center>
                <i class="fas fa-align-right text-white"></i>&nbsp;<img src="../../../assets/img/logojateng.png"
                    alt="Admin Logo" class="animation__shake wow fadeInDown" style="opacity: .8;height: 35px;">
            </center>
        </a>
        <!-- Sidebar -->
        <div class="sidebar wow fadeInLeft">
            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column nav-flat" data-widget="treeview" role="menu"
                    data-accordion="false">
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">&nbsp;</li>
                    <li class="nav-item">
                        <router-link to="/Dashboard"
                            :class="[(route.name == 'Dashboard' ? 'nav-link active' : 'nav-link')]" id="Dashboard"><i
                                class="nav-icon fas fa-chart-line"></i>
                            <p>DASHBOARD</p>
                        </router-link>
                    </li>
                    <li
                        :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'ProsesPDOMonev' || route.name == 'CEMP' || route.name == 'Sampel' || route.name == 'RKLRPL' || route.name == 'IPP' || route.name == 'GAP' || route.name == 'PDOIOS' || route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat' || route.name == 'ProsesPDOIOS' || route.name == 'Gesiap' || route.name == 'ProsesGesiap' || route.name == 'ProsesKurvaS' || route.name == 'KendalaTindakLanjut' || route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial' || route.name == 'DetailProsesGesiap' || route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#"
                            :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'ProsesPDOMonev' || route.name == 'CEMP' || route.name == 'Sampel' || route.name == 'RKLRPL' || route.name == 'IPP' || route.name == 'GAP' || route.name == 'PDOIOS' || route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat' || route.name == 'ProsesPDOIOS' || route.name == 'Gesiap' || route.name == 'ProsesGesiap' || route.name == 'ProsesKurvaS' || route.name == 'KendalaTindakLanjut' || route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial' || route.name == 'DetailProsesGesiap' || route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-server"></i>
                            <p>
                                MONITORING
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/PDOIOS"
                                    :class="[((route.name == 'PDOIOS' || route.name == 'ProsesPDOIOS') ? 'nav-link active' : 'nav-link')]"
                                    id="PDOIOS"><i class="nav-icon fab fa-dashcube"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">RESULT FRAMEWORK</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1">
                                <router-link :to="'/Monev/' + halamanawal"
                                    :class="[((route.name == 'Monev' || route.name == 'ProsesMonev' || route.name == 'ProsesPDOMonev' || route.name == 'ProsesKurvaS' || route.name == 'KendalaTindakLanjut') ? 'nav-link active' : 'nav-link')]"
                                    id="Monev"><i class="nav-icon fas fa-atom"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">MONEV PAKET PEKERJAAN</p>
                                </router-link>
                            </li>
                            <li v-if="leveluser == 1 || leveluser == 3"
                                :class="[((route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-item menu-open' : 'nav-item')]">
                                <a href="#" style="font-size: smaller;color: #ffffff;"
                                    :class="[((route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-link active' : 'nav-link')]">
                                    <i class="nav-icon fas fa-money-bill"></i>
                                    <p>
                                        FINANCE
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 3" style="display: none;">
                                        <router-link :to="'/DashboardFinance/' + halamanawal"
                                            :class="[((route.name == 'DashboardFinance') ? 'nav-link active' : 'nav-link')]"
                                            id="DashboardFinance"><i class="nav-icon fab fa-buromobelexperte"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">Dashboard Finance</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 3">
                                        <router-link :to="'/Finance/' + halamanawal"
                                            :class="[((route.name == 'Finance' || route.name == 'ProsesDIPA' || route.name == 'ProsesSPM') ? 'nav-link active' : 'nav-link')]"
                                            id="Finance"><i class="nav-icon fas fa-money-bill-wave"
                                                style="font-size: smaller;color: #ffffff;"></i>
                                            <p style="font-size: smaller;color: #ffffff;">OWP, AWP, DIPA, Realisasi</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1 || leveluser == 2 || leveluser == 6 || leveluser == 7">
                                <router-link to="/Gesiap"
                                    :class="[((route.name == 'Gesiap' || route.name == 'ProsesGesiap' || route.name == 'DetailProsesGesiap' ) ? 'nav-link active' : 'nav-link')]"
                                    id="Gesiap"><i class="nav-icon fas fa-bahai"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">GESIAP</p>
                                </router-link>
                            </li>
                            <li v-if="leveluser == 1 || leveluser == 2 || leveluser == 6 || leveluser == 7"
                                :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-item menu-open' : 'nav-item')]">
                                <a href="#" style="font-size: smaller;color: #ffffff;"
                                    :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment' || route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-link active' : 'nav-link')]">
                                    <i class="nav-icon fas fa-house-user"></i>
                                    <p>
                                        SAFEGUARD
                                        <i class="right fas fa-angle-left"></i>
                                    </p>
                                </a>
                                <ul class="nav nav-treeview">
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 7">
                                        <router-link :to="'/Environment/' + halamanawal"
                                            :class="[((route.name == 'Environment' || route.name == 'ProsesEnvironment') ? 'nav-link active' : 'nav-link')]"
                                            id="Environment"><i class="nav-icon fas fa-tint"
                                                style="font-size: 12px;color: #ffffff;"></i>
                                            <p style="font-size: 12px;color: #ffffff;">ENVIRONMENTAL</p>
                                        </router-link>
                                    </li>
                                    <li class="nav-item" v-if="leveluser == 1 || leveluser == 2 || leveluser == 6">
                                        <router-link :to="'/Social/' + halamanawal"
                                            :class="[((route.name == 'Social' || route.name == 'ProsesSocial') ? 'nav-link active' : 'nav-link')]"
                                            id="Social"><i class="nav-icon far fa-id-card"
                                                style="font-size: 12px;color: #ffffff;"></i>
                                            <p style="font-size: 12px;color: #ffffff;">SOCIAL</p>
                                        </router-link>
                                    </li>
                                </ul>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1">
                                <router-link to="/AduanMasyarakat"
                                    :class="[((route.name == 'AduanMasyarakat' || route.name == 'ProsesAduanMasyarakat' || route.name == 'TindaklanjutAduanMasyarakat') ? 'nav-link active' : 'nav-link')]"
                                    id="AduanMasyarakat"><i class="nav-icon fab fa-adn"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">DATA ADUAN</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/CEMP"
                                    :class="[((route.name == 'CEMP' || route.name == 'ProsesCEMP') ? 'nav-link active' : 'nav-link')]"
                                    id="CEMP"><i class="nav-icon fab fa-audible"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PERLINDUNGAN LINGKUNGAN (CEMP)</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/Sampel"
                                    :class="[((route.name == 'Sampel' || route.name == 'ProsesSampel') ? 'nav-link active' : 'nav-link')]"
                                    id="Sampel"><i class="nav-icon fas fa-cog"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PERLINDUNGAN LINGKUNGAN (PENGAMBILAN
                                        SAMPEL)</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/RKLRPL"
                                    :class="[((route.name == 'RKLRPL' || route.name == 'ProsesRKLRPL') ? 'nav-link active' : 'nav-link')]"
                                    id="RKLRPL"><i class="nav-icon far fa-clipboard"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PERLINDUNGAN LINGKUNGAN (RKL - RPL)
                                    </p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/IPP"
                                    :class="[((route.name == 'IPP' || route.name == 'ProsesIPP') ? 'nav-link active' : 'nav-link')]"
                                    id="IPP"><i class="nav-icon fab fa-codepen"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PROGRESS OF SOCIAL SAFEGUARD
                                        (INDIGENOUS PEOPLE & GENDER)</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display:none;">
                                <router-link to="/GAP"
                                    :class="[((route.name == 'GAP' || route.name == 'ProsesGAP') ? 'nav-link active' : 'nav-link')]"
                                    id="GAP"><i class="nav-icon fab fa-dashcube"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">GENDER ACTION PLAN</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li
                        :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'Slider'
                            || route.name == 'ProsesSlider' || route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda'
                            || route.name == 'Konten' || route.name == 'ProsesKonten'
                            || route.name == 'Berita' || route.name == 'ProsesBerita'
                            || route.name == 'KategoriData' || route.name == 'ProsesKategoriData'
                            || route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta'
                            || route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri'
                            || route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen'
                            || route.name == 'DataDokumen') ? 'nav-item menu-open' : 'nav-item')]">
                        <a href="#"
                            :class="[((route.name == 'User' || route.name == 'ProsesUser' || route.name == 'Slider'
                                || route.name == 'ProsesSlider' || route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda'
                                || route.name == 'Konten' || route.name == 'ProsesKonten'
                                || route.name == 'Berita' || route.name == 'ProsesBerita'
                                || route.name == 'KategoriData' || route.name == 'ProsesKategoriData'
                                || route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta'
                                || route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri'
                                || route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen'
                                || route.name == 'DataDokumen') ? 'nav-link active' : 'nav-link')]">
                            <i class="nav-icon fas fa-tablets"></i>
                            <p>
                                PENGATURAN
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview">
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Kategori"
                                    :class="[((route.name == 'Kategori' || route.name == 'ProsesKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="Kategori"><i class="nav-icon fas fa-bahai"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">KATEGORI DATA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/SubKategori"
                                    :class="[((route.name == 'SubKategori' || route.name == 'ProsesSubKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="SubKategori"><i class="nav-icon fab fa-bandcamp"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">SUB KATEGORI DATA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/UnitKategori"
                                    :class="[((route.name == 'UnitKategori' || route.name == 'ProsesUnitKategori') ? 'nav-link active' : 'nav-link')]"
                                    id="UnitKategori"><i class="nav-icon fab fa-bitbucket"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">UNIT KATEGORI DATA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/Slider"
                                    :class="[((route.name == 'Slider' || route.name == 'ProsesSlider') ? 'nav-link active' : 'nav-link')]"
                                    id="Slider"><i class="nav-icon fas fa-camera"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">SLIDER GAMBAR</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/InfoBeranda"
                                    :class="[((route.name == 'InfoBeranda' || route.name == 'ProsesInfoBeranda') ? 'nav-link active' : 'nav-link')]"
                                    id="InfoBeranda"><i class="nav-icon fas fa-box"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">INFO BERANDA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/Konten"
                                    :class="[((route.name == 'Konten' || route.name == 'ProsesKonten') ? 'nav-link active' : 'nav-link')]"
                                    id="Konten"><i class="nav-icon fas fa-book"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">KONTEN WEB</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/Berita"
                                    :class="[((route.name == 'Berita' || route.name == 'ProsesBerita') ? 'nav-link active' : 'nav-link')]"
                                    id="Berita"><i class="nav-icon fas fa-bold"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">BERITA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/Galeri"
                                    :class="[((route.name == 'Galeri' || route.name == 'ProsesGaleri' || route.name == 'DetailGaleri') ? 'nav-link active' : 'nav-link')]"
                                    id="Galeri"><i class="nav-icon fas fa-photo-video"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">GALERI</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Dokumen"
                                    :class="[((route.name == 'Dokumen' || route.name == 'ProsesDokumen' || route.name == 'DetailDokumen') ? 'nav-link active' : 'nav-link')]"
                                    id="Dokumen"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">DOKUMEN</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1">
                                <router-link to="/DataDokumen"
                                    :class="[((route.name == 'DataDokumen') ? 'nav-link active' : 'nav-link')]"
                                    id="DataDokumen"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">DOKUMEN</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="leveluser == 1" style="display: none;">
                                <router-link to="/Regulasi"
                                    :class="[((route.name == 'Regulasi' || route.name == 'ProsesRegulasi') ? 'nav-link active' : 'nav-link')]"
                                    id="Regulasi"><i class="nav-icon far fa-file-pdf"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">REGULASI</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'" style="display: none;">
                                <router-link to="/KategoriData"
                                    :class="[((route.name == 'KategoriData' || route.name == 'ProsesKategoriData') ? 'nav-link active' : 'nav-link')]"
                                    id="KategoriData"><i class="nav-icon fas fa-boxes"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">KATEGORI DATA PETA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/LayerPeta"
                                    :class="[((route.name == 'LayerPeta' || route.name == 'ProsesLayerPeta') ? 'nav-link active' : 'nav-link')]"
                                    id="LayerPeta"><i class="nav-icon fas fa-layer-group"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">LAYER PETA</p>
                                </router-link>
                            </li>
                            <li class="nav-item" v-if="roleuser == 'admin'">
                                <router-link to="/User"
                                    :class="[((route.name == 'User' || route.name == 'ProsesUser') ? 'nav-link active' : 'nav-link')]"
                                    id="User"><i class="nav-icon fas fa-user-friends"
                                        style="font-size: smaller;color: #ffffff;"></i>
                                    <p style="font-size: smaller;color: #ffffff;">PENGGUNA</p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                    <li class="nav-item">
                        <a href="#" class="nav-link" @click="keluar()">
                            <i class="nav-icon fas fa-sign-out-alt"></i>
                            <p>KELUAR / LOGOUT</p>
                        </a>
                    </li>

                    <li>&nbsp;</li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>
</template>

<script>
import { useRoute } from 'vue-router';
import { watch } from 'vue';
import swal from 'sweetalert2';
import CryptoJS from 'crypto-js';
export default {
    components: {
        swal
    },
    setup() {
        const route = useRoute()
        watch(() => route.name, () => {
        });

        return { route };
    },
    data() {
        return {
            tahun: new Date().getFullYear(),
            namauser: JSON.parse(localStorage.getItem("nmusistem")),
            leveluser: JSON.parse(localStorage.getItem("lsistem")),
            roleuser: JSON.parse(localStorage.getItem("rlsistem")),
            folderawal: encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
            halamanawal: encodeURIComponent(CryptoJS.AES.encrypt('_1________', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString()),
        };
    },
    methods: {
        getOtentifikasi() {
            var time = Date.parse(localStorage.getItem("tsistem"));
            var timeakhir = time + (3 * 60 * 60 * 1000);
            var timesekarang = Date.parse(new Date());
            if (timesekarang > timeakhir) {
                localStorage.removeItem('tokensistem');
                localStorage.removeItem('usistem');
                localStorage.removeItem('lsistem');
                localStorage.removeItem('inssistem');
                localStorage.removeItem('rlsistem');
                localStorage.removeItem('nmlsistem');
                localStorage.removeItem('emlsistem');
                localStorage.removeItem('nmusistem');
                localStorage.removeItem('tsistem');
                localStorage.removeItem('orsistem');
                localStorage.removeItem('bdlsistem');
                localStorage.removeItem('sbdsistem');
                localStorage.removeItem('jbtsistem');
            }
        },
        pindahawalnya1() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data/" + bytes);
        },
        pindahawalnya3() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data3/" + bytes);
        },
        pindahawalnya4() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data4/" + bytes);
        },
        pindahawalnya5() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data5/" + bytes);
        },
        pindahawalnya6() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data6/" + bytes);
        },
        pindahawalnya7() {
            var bytes = encodeURIComponent(CryptoJS.AES.encrypt('0', 'oriproMop8LQ06S0rZXcJyEH3wk8jVrINbHwn7tBq2').toString());
            window.location.replace("/Data7/" + bytes);
        },
        keluar() {
            swal.fire({
                title: "Konfirmasi",
                text: "Yakin Hendak Keluar Aplikasi?",
                icon: "warning",
                showCancelButton: true,
                cancelButtonText: "Batal",
                confirmButtonColor: "#005c95",
                cancelButtonColor: "#ffaa05",
                confirmButtonText: "Keluar"
            }).then((result) => {
                if (result.isConfirmed) {
                    this.ClearlocalStorage();
                }
            });

            return false;
        },
    },
    mounted() {
        this.getOtentifikasi();
        if ((localStorage.getItem("tokensistem") == null)) {
            window.location.replace("/Login");
        }
    }
}
</script>

<style></style>